var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _rect, _path9, _rect2, _path10, _path11, _path12, _path13, _rect3, _path14, _path15, _path16, _rect4, _g, _path17, _rect5, _path18, _path19, _rect6, _rect7, _path20, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _g2, _path21, _path22, _path23, _g3, _g4, _g5, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptyList(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 384.101,
    height: 222.487,
    viewBox: "0 0 384.101 222.487",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group_1588",
    "data-name": "Group 1588",
    transform: "translate(-262 -182.179)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3795",
    "data-name": "Path 3795",
    d: "M149.225,224.494H319.971v-47.15a5.525,5.525,0,0,1,2.958,3.239h2.545v49.565H66.05V80.98H325.474v54.011a19.061,19.061,0,0,0-5.5-1.892V86.644H71.553v137.85h77.672Z",
    transform: "translate(260.565 101.199)",
    fill: "#dbe3eb"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3796",
    "data-name": "Path 3796",
    d: "M374.534,145.062v45.591h-2.545a5.525,5.525,0,0,0-2.958-3.239V143.17A19.061,19.061,0,0,1,374.534,145.062Z",
    transform: "translate(211.505 91.129)",
    fill: "#dbe3eb"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3797",
    "data-name": "Path 3797",
    d: "M361.365,224.323v23H322.252c-.564-1.338-.8-3.209-.282-4.114,1.8-3.149,6.027-.886,8.149-2.746,1.942-1.7.181-2.817-.251-4.628-.563-2.324,2.163-3.159,4.034-3.42,2.756-.392,4.074-.613,4.657-3.722.322-1.711-.06-3.884,1.258-5.3,2.525-2.706,5.835-1.027,8.44.422,1.7.945,3.279,2.495,5.3,1.731C355.681,224.736,359.414,221.265,361.365,224.323Z",
    transform: "translate(219.171 78.373)",
    fill: "#ccd9e2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3798",
    "data-name": "Path 3798",
    d: "M364.823,155.894v33.58c-2.243-.946-5.08-.342-7.856-1.57-5.261-2.324-6.791-8.249-10.563-12.263a14.763,14.763,0,0,0-3.36-2.656V155.894Z",
    transform: "translate(215.713 89.069)",
    fill: "#f9fbfc"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3799",
    "data-name": "Path 3799",
    d: "M359.406,142.276V152.94H337.627v17.092c-5.1-2.948-11.771-2.807-15.342,2.565s-3.943,10.724-12.283,6.82c-.131-.06-.272-.131-.412-.191V137.649a37.765,37.765,0,0,1,13.087,17.7c-.272-5.654,3.562-10.463,8.5-11.337a10.61,10.61,0,0,1,10.473,4.818,19.9,19.9,0,0,1,13.6-6.8A17.935,17.935,0,0,1,359.406,142.276Z",
    transform: "translate(221.13 92.023)",
    fill: "#edf1f5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3800",
    "data-name": "Path 3800",
    d: "M345.69,87.738v46.456a17.934,17.934,0,0,0-4.154-.251,19.9,19.9,0,0,0-13.6,6.8,10.61,10.61,0,0,0-10.473-4.818c-4.939.875-8.772,5.684-8.5,11.337a37.766,37.766,0,0,0-13.087-17.7V113.039H240.735v17.937a15.256,15.256,0,0,0-6.83.7,15.471,15.471,0,0,0-9.024,8.189V87.738Z",
    transform: "translate(234.846 100.105)",
    fill: "#f9fbfc"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3801",
    "data-name": "Path 3801",
    d: "M253.941,213.823h13.5a10.161,10.161,0,0,0-4.879,3.39,6.839,6.839,0,0,0-1.257,3.692h-7.364Z",
    transform: "translate(230.141 79.689)",
    fill: "#f9fbfc"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3802",
    "data-name": "Path 3802",
    d: "M253.941,235.153h8.964c-.433,2.6-2.324,4.648-3.18,7.083h-5.784Z",
    transform: "translate(230.141 76.235)",
    fill: "#f9fbfc"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1985",
    "data-name": "Rectangle 1985",
    width: 15.854,
    height: 60.057,
    transform: "translate(459.727 265.636)",
    fill: "#c7d3db"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3803",
    "data-name": "Path 3803",
    d: "M240.735,139.306v34.556H224.881V148.2a15.471,15.471,0,0,1,9.024-8.189A15.257,15.257,0,0,1,240.735,139.306Z",
    transform: "translate(234.846 91.774)",
    fill: "#edf1f5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1986",
    "data-name": "Rectangle 1986",
    width: 6.8,
    height: 60.057,
    transform: "translate(452.927 265.636)",
    fill: "#dbe3eb"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3804",
    "data-name": "Path 3804",
    d: "M216.767,132.917V87.738h6.8v77.793h-6.8Z",
    transform: "translate(236.16 100.105)",
    fill: "#dbe3eb"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3805",
    "data-name": "Path 3805",
    d: "M212.9,180.561v60.057h-3.783V189.253H192.867v-8.692Z",
    transform: "translate(240.03 85.075)",
    fill: "#c7d3db"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3806",
    "data-name": "Path 3806",
    d: "M193.425,138.548v32.614H173.4V146.526H140.359v-5.191H114.868v5.191H97.494v35.038c-.151-.131-.3-.272-.453-.412a14.943,14.943,0,0,0-3.612-2.585v-20.8H72.616v-4.667a17.854,17.854,0,0,1,8.6.362c1.1-12.554,8.561-23.51,19.546-28.329,13.651-5.975,30.562-1.5,40.5,11.337,1.107-3.611,3.8-6.428,7.083-7.082,4.718-.956,10.24,2.645,11.609,8.782a22.553,22.553,0,0,1,22.383-6.8A21.755,21.755,0,0,1,193.425,138.548Z",
    transform: "translate(259.502 94.474)",
    fill: "#edf1f5"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3807",
    "data-name": "Path 3807",
    d: "M193.425,87.738v45.179a21.755,21.755,0,0,0-11.086-7.183,22.553,22.553,0,0,0-22.383,6.8c-1.369-6.137-6.891-9.738-11.609-8.782-3.279.654-5.975,3.47-7.083,7.082-9.939-12.837-26.849-17.313-40.5-11.337-10.985,4.819-18.449,15.774-19.546,28.329a17.854,17.854,0,0,0-8.6-.362V87.738Z",
    transform: "translate(259.502 100.105)",
    fill: "#f9fbfc"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1987",
    "data-name": "Rectangle 1987",
    width: 16.247,
    height: 51.366,
    transform: "translate(432.897 274.328)",
    fill: "#edf1f5"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3808",
    "data-name": "Path 3808",
    d: "M178.2,184.493v51.366h-8.409c-.363-1.8-2.535-3.018-4.477-3.953h4.417v-6.549h-6.56v5.512a.572.572,0,0,0-.07-.04c-4.889-2.705-3.591-6.71-3.4-11.125.221-5.312-3.239-7.565-7.445-8.7v-1.972h-6.549v.865c-.292-.03-.583-.07-.865-.1-6.9-.794-3.31-4.718-5.181-8.792-.955-2.113-2.978-2.565-4.869-3.2v-5.09h-4.315c-.342-2.565.02-5.2-3.058-7.112-6.076-3.773-10.965-.423-16.438,2.172-3.863,1.831-5.855.976-8.682-1.569V151.165h75.9v33.328Zm-8.47,31.1v-6.559h-6.56v6.559Zm0-16.327v-6.549h-6.56v6.549Zm0-16.316v-6.56h-6.56v6.56Zm0-16.327v-6.549h-6.56v6.549ZM152.258,199.26v-6.549h-6.549v6.549Zm0-16.316v-6.56h-6.549v6.56Zm0-16.327v-6.549h-6.549v6.549Zm-17.464,16.327v-6.56h-6.549v6.56Zm0-16.327v-6.549h-6.549v6.549ZM117.33,182.944v-6.56h-6.549v6.56Zm0-16.327v-6.549h-6.549v6.549Z",
    transform: "translate(254.695 89.835)",
    fill: "#f9fbfc"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3809",
    "data-name": "Path 3809",
    d: "M129.987,203.835c1.892.634,3.914,1.086,4.869,3.2,1.871,4.074-1.721,8,5.181,8.792.282.03.573.07.865.1a45.094,45.094,0,0,1,6.549,1.107c4.205,1.136,7.666,3.39,7.445,8.7-.191,4.416-1.489,8.42,3.4,11.125a.575.575,0,0,1,.07.04v1.037h2.143c1.942.935,4.114,2.153,4.477,3.953h-14.7c-1.871-.764-2.072-2.837-2.192-4.96-.241-4.144-3.693-3.169-6.56-4.325-3.018-1.217-2.505-6.136-4.979-8.179-3.341-2.746-7.083-1.227-9.135,1.912-1.9,2.907-3.028-.161-5.523.211a4.72,4.72,0,0,0-3.631,2.093c-1.659,2.343-2.857,2.092-5.442.282-2.766-1.942-4.325-4.688-7.635-5.935-2.978-1.107-7.243-1.107-9.467,1.539-1.68,1.982-1.126,4.537-2.153,6.741-1.317,2.836-3.4,1.1-5.643.553-2.113-.523-4.879.02-5.654,2.394-.524,1.6.412,3.239-1.338,4.245-1.257.724-3,.483-3.963,1.711a3.159,3.159,0,0,0-.644,1.72H72.616V195.767c3.812,1.6,9.084-3.35,11.881-5.292,3.35-2.324,6.157-2.585,8.933-1.237a14.942,14.942,0,0,1,3.612,2.585c.151.141.3.282.453.412,2.827,2.545,4.819,3.4,8.682,1.569,5.473-2.6,10.362-5.945,16.438-2.172,3.078,1.911,2.716,4.547,3.058,7.112a7.211,7.211,0,0,0,.825,2.706A5.624,5.624,0,0,0,129.987,203.835Z",
    transform: "translate(259.502 83.802)",
    fill: "#c7d3db"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3811",
    "data-name": "Path 3811",
    d: "M151.005,248.435H77.045a3.159,3.159,0,0,1,.644-1.72c.965-1.228,2.706-.986,3.963-1.711,1.751-1.006.815-2.646,1.338-4.245.774-2.374,3.541-2.917,5.654-2.394,2.243.543,4.325,2.283,5.643-.553,1.027-2.2.474-4.759,2.153-6.741,2.223-2.646,6.489-2.646,9.467-1.539,3.31,1.247,4.868,3.993,7.635,5.935,2.585,1.81,3.783,2.062,5.442-.282a4.72,4.72,0,0,1,3.631-2.093c2.495-.372,3.622,2.7,5.523-.211,2.052-3.139,5.794-4.658,9.135-1.912,2.474,2.042,1.961,6.962,4.979,8.179,2.867,1.157,6.318.181,6.56,4.325C148.933,245.6,149.135,247.671,151.005,248.435Z",
    transform: "translate(258.784 77.258)",
    fill: "#edf1f5"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1995",
    "data-name": "Rectangle 1995",
    width: 25.492,
    height: 5.191,
    transform: "translate(374.369 235.808)",
    fill: "#c7d3db"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_638",
    "data-name": "Group 638",
    transform: "translate(365.476 249.902)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3810",
    "data-name": "Path 3810",
    d: "M181.494,239.691v6.549h-4.417c-.8-.382-1.57-.724-2.143-1.037v-5.512Z",
    transform: "translate(-122.542 -174.402)",
    fill: "#dbe3eb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1988",
    "data-name": "Rectangle 1988",
    width: 6.559,
    height: 6.559,
    transform: "translate(52.392 48.961)",
    fill: "#dbe3eb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1989",
    "data-name": "Rectangle 1989",
    width: 6.559,
    height: 6.549,
    transform: "translate(52.392 32.644)",
    fill: "#dbe3eb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1990",
    "data-name": "Rectangle 1990",
    width: 6.559,
    height: 6.559,
    transform: "translate(52.392 16.317)",
    fill: "#dbe3eb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1991",
    "data-name": "Rectangle 1991",
    width: 6.559,
    height: 6.549,
    transform: "translate(52.392 0)",
    fill: "#dbe3eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3812",
    "data-name": "Path 3812",
    d: "M160.645,220.209v1.972a45.09,45.09,0,0,0-6.549-1.107v-.865Z",
    transform: "translate(-119.168 -171.248)",
    fill: "#dbe3eb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1992",
    "data-name": "Rectangle 1992",
    width: 6.549,
    height: 6.549,
    transform: "translate(34.928 32.644)",
    fill: "#dbe3eb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1993",
    "data-name": "Rectangle 1993",
    width: 6.549,
    height: 6.559,
    transform: "translate(34.928 16.317)",
    fill: "#dbe3eb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1994",
    "data-name": "Rectangle 1994",
    width: 6.549,
    height: 6.549,
    transform: "translate(34.928 0)",
    fill: "#dbe3eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3813",
    "data-name": "Path 3813",
    d: "M140.238,200.739v5.09a5.624,5.624,0,0,1-3.491-2.384,7.211,7.211,0,0,1-.825-2.706Z",
    transform: "translate(-116.226 -168.095)",
    fill: "#dbe3eb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1996",
    "data-name": "Rectangle 1996",
    width: 6.549,
    height: 6.559,
    transform: "translate(17.464 16.317)",
    fill: "#dbe3eb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1997",
    "data-name": "Rectangle 1997",
    width: 6.549,
    height: 6.549,
    transform: "translate(17.464 0)",
    fill: "#dbe3eb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1998",
    "data-name": "Rectangle 1998",
    width: 6.549,
    height: 6.559,
    transform: "translate(0 16.317)",
    fill: "#dbe3eb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1999",
    "data-name": "Rectangle 1999",
    width: 6.549,
    height: 6.549,
    transform: "translate(0 0)",
    fill: "#dbe3eb"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3814",
    "data-name": "Path 3814",
    d: "M93.43,164.572v20.8c-2.777-1.348-5.583-1.087-8.933,1.237-2.8,1.942-8.068,6.891-11.881,5.292V164.572Z",
    transform: "translate(259.502 87.664)",
    fill: "#f9fbfc"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2001",
    "data-name": "Rectangle 2001",
    width: 19.37,
    height: 35.856,
    transform: "translate(516.35 221.965)",
    fill: "#f9fbfc"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3815",
    "data-name": "Path 3815",
    d: "M268.471,207.374c3.954-1.55,8.6-2.244,9.869-5.774a13.366,13.366,0,0,0,.613-5.01c-.06-2.394-.382-4.819.05-7.082a8.239,8.239,0,0,1,3.018-5.05c6.207-5.111,13.511-2.173,19.587.654.141.06.282.131.412.191,8.34,3.9,8.722-1.458,12.283-6.82s10.241-5.513,15.342-2.565a14.762,14.762,0,0,1,3.36,2.656c3.772,4.014,5.3,9.939,10.563,12.263,2.776,1.228,5.613.624,7.856,1.57v24.153c-1.951-3.058-5.684.412-7.806,1.218-2.022.764-3.6-.785-5.3-1.731-2.606-1.449-5.915-3.129-8.44-.422-1.318,1.418-.936,3.591-1.258,5.3-.583,3.108-1.9,3.33-4.657,3.722-1.871.261-4.6,1.1-4.034,3.42.432,1.811,2.193,2.927.251,4.628-2.122,1.861-6.348-.4-8.149,2.746-.513.905-.282,2.777.282,4.114H261.39a10.464,10.464,0,0,1-1.047-5.533,6.393,6.393,0,0,1,.412-1.69c.856-2.435,2.746-4.487,3.18-7.083a6.292,6.292,0,0,0,.1-.986c.05-3.33-1.871-6.549-1.7-9.809a6.839,6.839,0,0,1,1.257-3.692A10.161,10.161,0,0,1,268.471,207.374Z",
    transform: "translate(229.111 86.138)",
    fill: "#c7d3db"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3816",
    "data-name": "Path 3816",
    d: "M243.8,135.863V117.927h55.139v58.105c-6.076-2.827-13.38-5.764-19.587-.654a8.239,8.239,0,0,0-3.018,5.05H252.3v7.082h23.983a13.366,13.366,0,0,1-.613,5.01c-1.268,3.531-5.915,4.225-9.869,5.774H252.3v7.082h7.364c-.171,3.26,1.751,6.479,1.7,9.809a6.292,6.292,0,0,1-.1.986H252.3v7.083h5.784a6.39,6.39,0,0,0-.412,1.69,10.465,10.465,0,0,0,1.047,5.533H243.8V135.863Zm48.861,33.761v-7.073H252.289v7.073Zm0-17.866v-7.083H252.289v7.083Zm0-17.877V126.8H252.289v7.082Z",
    transform: "translate(231.783 95.217)",
    fill: "#dbe3eb"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2002",
    "data-name": "Rectangle 2002",
    width: 40.37,
    height: 7.072,
    transform: "translate(484.072 257.769)",
    fill: "#f9fbfc"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2003",
    "data-name": "Rectangle 2003",
    width: 40.37,
    height: 7.082,
    transform: "translate(484.072 239.893)",
    fill: "#f9fbfc"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3817",
    "data-name": "Path 3817",
    d: "M253.941,192.505h24.034c-.432,2.263-.111,4.687-.05,7.082H253.941Z",
    transform: "translate(230.141 83.141)",
    fill: "#f9fbfc"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2004",
    "data-name": "Rectangle 2004",
    width: 40.37,
    height: 7.082,
    transform: "translate(484.072 222.016)",
    fill: "#f9fbfc"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2005",
    "data-name": "Rectangle 2005",
    width: 3.37,
    height: 84.694,
    transform: "translate(432.897 240.999)",
    fill: "#c7d3db"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2006",
    "data-name": "Rectangle 2006",
    width: 3.37,
    height: 84.694,
    transform: "translate(472.211 213.143)",
    fill: "#c7d3db"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2007",
    "data-name": "Rectangle 2007",
    width: 3.37,
    height: 44.731,
    transform: "translate(555.387 244.963)",
    fill: "#c7d3db"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2008",
    "data-name": "Rectangle 2008",
    width: 2.465,
    height: 49.094,
    transform: "translate(352.931 252.236)",
    fill: "#c7d3db"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2009",
    "data-name": "Rectangle 2009",
    width: 379.549,
    height: 13.729,
    rx: 6.823,
    transform: "translate(266.552 390.938)",
    fill: "#dbe3eb"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_634",
    "data-name": "Group 634",
    transform: "translate(299.091 354.593)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3818",
    "data-name": "Path 3818",
    d: "M49.4,286.706c0,.005-.565,1.676-1.16,3.773a37.1,37.1,0,0,0-1.359,6.364l1,.075a36.415,36.415,0,0,1,1.323-6.165c.294-1.037.582-1.97.795-2.643s.351-1.084.351-1.084l-.953-.321Z",
    transform: "translate(-35.423 -286.706)",
    fill: "#517073"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3819",
    "data-name": "Path 3819",
    d: "M39.157,287.673s.02.169.05.478c.091.926.274,3.081.273,5.422,0,1.1-.039,2.233-.147,3.3l1,.1c.111-1.112.152-2.279.152-3.4a57.975,57.975,0,0,0-.331-6.017l-1,.117Z",
    transform: "translate(-34.172 -286.844)",
    fill: "#517073"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3820",
    "data-name": "Path 3820",
    d: "M33.209,295.5l0,0a3.8,3.8,0,0,1,.43.625,2.57,2.57,0,0,1,.355,1.21H35a3.634,3.634,0,0,0-.529-1.782,4.548,4.548,0,0,0-.525-.738l-.742.68Z",
    transform: "translate(-33.209 -288.02)",
    fill: "#517073"
  }))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3821",
    "data-name": "Path 3821",
    d: "M48.137,281.039s-5.156-6.54,2.766-20.12,24.269-16.85,25.023-15.09-8.3,5.156-10.814,15.593-2.85,16.221-5.994,19.365S51.7,285.188,48.137,281.039Z",
    transform: "translate(263.732 74.577)",
    fill: "#24dcae"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3823",
    "data-name": "Path 3823",
    d: "M38.543,276.055s8.88-9.536-1.418-24.793S4.12,234.94,3.373,237.055,12.26,243.161,16,255.16s5.78,18.013,9.694,21.444S34.7,281.177,38.543,276.055Z",
    transform: "translate(270.72 76.06)",
    fill: "#24dcae",
    opacity: 0.45
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3822",
    "data-name": "Path 3822",
    d: "M28.207,287.056s-.566-7.354-13.878-11.447S-11.6,279.2-11.031,280.8s8.5-1.623,16.4,3.667,11.593,8.858,15.528,9.019S28.376,291.9,28.207,287.056Z",
    transform: "translate(273.049 69.876)",
    fill: "#63e8c7"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_635",
    "data-name": "Group 635",
    transform: "translate(313.462 324.949)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3824",
    "data-name": "Path 3824",
    d: "M50.86,279.984a.5.5,0,0,1-.485-.638c.23-.83,5.753-20.428,15.966-27.914a.5.5,0,0,1,.594.812C57,259.522,51.4,279.415,51.344,279.615A.5.5,0,0,1,50.86,279.984Z",
    transform: "translate(-50.356 -251.334)",
    fill: "#f9fbfc"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_636",
    "data-name": "Group 636",
    transform: "translate(280.893 314.617)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3825",
    "data-name": "Path 3825",
    d: "M34.281,275.5a.552.552,0,0,1-.5-.375,2.253,2.253,0,0,1-.059-.546c-.461-6.893-3.4-29.76-21.849-34.588a.5.5,0,1,1,.255-.973c19.1,5,22.125,28.431,22.6,35.494.013.19.02.313.027.363a.473.473,0,0,1-.327.6A.481.481,0,0,1,34.281,275.5Z",
    transform: "translate(-11.494 -239.006)",
    fill: "#f9fbfc"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_637",
    "data-name": "Group 637",
    transform: "translate(272.033 347.803)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3826",
    "data-name": "Path 3826",
    d: "M26.355,291.074c-.228,0-.453-.2-1.187-.868-8.274-7.488-16.249-11.033-23.71-10.55a.5.5,0,0,1-.065-1c7.745-.515,15.966,3.13,24.45,10.808.294.267.6.541.715.631a.5.5,0,0,1-.018.948A.576.576,0,0,1,26.355,291.074Z",
    transform: "translate(-0.923 -278.604)",
    fill: "#f9fbfc"
  }))), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3827",
    "data-name": "Path 3827",
    d: "M49.31,328.26H23.373a1.4,1.4,0,0,1-1.366-1.086l-6.394-27.626a1.4,1.4,0,0,1,1.366-1.718H55.7a1.4,1.4,0,0,1,1.366,1.718l-6.393,27.626A1.4,1.4,0,0,1,49.31,328.26Z",
    transform: "translate(268.738 66.086)",
    fill: "#c7d3db"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3828",
    "data-name": "Path 3828",
    d: "M346.1,190.01a2.6,2.6,0,1,1,0,5.191,2.6,2.6,0,0,1,0-5.191Z",
    transform: "translate(215.634 83.545)",
    fill: "#f8e8ab"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3829",
    "data-name": "Path 3829",
    d: "M346.428,169.976c4.276,0,6.438,2.374,6.438,4.98,0,4.919-5.473,4.5-5.473,8.048v.915H343.42v-1.066c0-5.221,4.92-4.829,4.92-7.5,0-1.237-.886-1.942-2.334-1.942a4.905,4.905,0,0,0-3.712,1.912l-2.787-2.153A8.661,8.661,0,0,1,346.428,169.976Z",
    transform: "translate(216.285 86.789)",
    fill: "#f8e8ab"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3830",
    "data-name": "Path 3830",
    d: "M420.743,325.365c.211.593-3.943,7.847-4.658,8.43s-6.388,1.006-6.539.141,3.229-2.716,3.229-2.716l.634-3.732,3.893-4.779A41.764,41.764,0,0,1,420.743,325.365Z",
    transform: "translate(204.945 62.057)",
    fill: "#739092"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3831",
    "data-name": "Path 3831",
    d: "M366.811,332.024c1.208,2.485,1.952,4.154,1.821,4.366-.563.946-15.371,2.455-15.623.856s7.293-4.688,7.293-4.688A9.6,9.6,0,0,0,366.811,332.024Z",
    transform: "translate(214.1 60.549)",
    fill: "#739092"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3832",
    "data-name": "Path 3832",
    d: "M289.082,233.914a32.364,32.364,0,1,1,1.519-4.95l-.794,2.947C289.586,232.586,289.354,233.26,289.082,233.914Zm-4.808-12a25.607,25.607,0,1,0-25.6,25.612A25.605,25.605,0,0,0,284.274,221.912Z",
    transform: "translate(234.669 83.673)",
    fill: "#a5b7c6"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3833",
    "data-name": "Path 3833",
    d: "M333.638,241.686l3.963.795.2.04,1.871.382-.976,6.046-2.1-.422-20.23-4.054c-.554-.221-1.188-.594-1.308-1.147-.181-.875-2.465-1.549-3.42-1.73a1.815,1.815,0,0,0-.322-.05c-.5-.03-1.57.372-.815,1.76l-9.226-1.891c.272-.655.5-1.328.725-2,.272-.855.513-1.731.714-2.606.03-.111.05-.231.08-.342l.251-.925,21.216,4.265h.01Z",
    transform: "translate(222.476 76.172)",
    fill: "#a5b7c6"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3834",
    "data-name": "Path 3834",
    d: "M375.577,281.4s10.131-5.352,12.646-11.961c-2.284,9.426-12.083,19.515-12.083,19.515-.372-4.1-.553-7.524-.553-7.524Z",
    transform: "translate(210.445 70.683)",
    fill: "#13258d"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3835",
    "data-name": "Path 3835",
    d: "M417.474,255.912l-2.384,10.181-28.842-6.247-2.183-.473-25.693-5.563-12.636-2.736.161-1.027.091.02.905-6.066h-.02l.251-1.589c.05-.03.09-.06.141-.09l6.187,1.2,24.124,4.668,2.575.5,18.842,3.641.05.01.332.07a4.433,4.433,0,0,1,2.8,1.741c.886,1.509-.885,4.979-.04,4.778,4.427-1.036,4.2-4.164,4.024-5.21Z",
    transform: "translate(215.277 75.074)",
    fill: "#739092"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3836",
    "data-name": "Path 3836",
    d: "M411.912,313.788l-3.893,4.779-.5.352c-.563.131-26.98-13.7-28.922-16.911-1.1-1.8-1.871-8.129-2.344-13.35,0,0,9.8-10.09,12.083-19.515a8.533,8.533,0,0,0,.443-1.529v.07c1.318,15.15-2.384,22-.372,26.528C389.951,297.7,405,308.677,411.912,313.788Z",
    transform: "translate(210.336 70.979)",
    fill: "#3b55eb"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3837",
    "data-name": "Path 3837",
    d: "M416.431,255.006c.171,1.046.4,4.174-4.024,5.21-.845.2.926-3.269.04-4.778a4.433,4.433,0,0,0-2.8-1.741l-.332-.07-.05-.01c-.05-.02-.08-.02-.08-.03,0-.05.845-1.116.845-1.116l.825-.453,3.139-1.74.03-.01c1.408,2.676,2.344,4.476,2.344,4.476S416.39,254.835,416.431,255.006Z",
    transform: "translate(205.003 73.787)",
    fill: "#f8e8ab"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3838",
    "data-name": "Path 3838",
    d: "M404.483,244.874l-.03.01-3.139,1.74s-12.495-17.414-14.476-18.691-19.054-4.889-20.473-3.541c-.885.845,5.905,10.22,11.942,19.687l-24.124-4.668c-.845-1.942-1.559-3.7-2-5.09-.271-.935-.533-1.881-.774-2.847a30.171,30.171,0,0,1-.915-11.569s1.066.533,6.348-2.646a26.624,26.624,0,0,1,7.374-.08c4.446.543,24.7,3.4,27.121,5.2C393.116,223.7,400.6,237.55,404.483,244.874Z",
    transform: "translate(214.546 79.181)",
    fill: "#536dfe"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3839",
    "data-name": "Path 3839",
    d: "M404.413,248l-.825.453s-9.818-13.5-13.409-15.895-11.76-4.335-18.108-4.648c0,0,6.5,9.2,11.911,18.048l-2.575-.5c-6.037-9.467-12.827-18.842-11.942-19.687,1.419-1.348,18.48,2.263,20.473,3.541S404.413,248,404.413,248Z",
    transform: "translate(211.447 77.802)",
    fill: "#3b55eb"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3840",
    "data-name": "Path 3840",
    d: "M394.759,266.873l-1.55-.03a30.387,30.387,0,0,0-1.74-4.174l2.183.473A11.79,11.79,0,0,1,394.759,266.873Z",
    transform: "translate(207.871 71.78)",
    fill: "#3b55eb"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3841",
    "data-name": "Path 3841",
    d: "M388.246,265.768l-1.971-.03-18.028-.332-1.871-.03-.724-.01s-2.264-4.206-4.839-9.335l25.693,5.563A30.39,30.39,0,0,1,388.246,265.768Z",
    transform: "translate(212.835 72.854)",
    fill: "#536dfe"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3842",
    "data-name": "Path 3842",
    d: "M364.926,267.211l18.028.332a8.534,8.534,0,0,1-.442,1.529c-2.515,6.609-12.646,11.961-12.646,11.961-4.4,2.384-17.253,9.516-18.027,11.911-.734,2.244,8.8,20.13,12.916,28.58a9.6,9.6,0,0,1-6.509.533s-17.524-24.314-17.937-30.763c-.412-6.287,21.548-23.188,22.745-24.113Z",
    transform: "translate(216.156 71.049)",
    fill: "#3b55eb"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3843",
    "data-name": "Path 3843",
    d: "M351.758,210.285a19.318,19.318,0,0,1,1.911,1.962,2.927,2.927,0,0,0,.111.382c.675,1.761,1.1,2.676,1.761,2.676-5.282,3.179-6.348,2.646-6.348,2.646l-.06.09a6.342,6.342,0,0,0-1.419-3.43,16.17,16.17,0,0,1-3.521.191c-.453-.211-1.781-5.754-1.962-9.446.343-.07,4.034-.866,4.779-.211.774.694.483,3.46,1.469,3.289s.332-1.278.563-1.489a1.3,1.3,0,0,1,1.619.986,3.746,3.746,0,0,1,.121,1.488l.1.02s.1.1.272.261c.08.08.181.171.282.272S351.648,210.165,351.758,210.285Z",
    transform: "translate(215.844 81.135)",
    fill: "#f8e8ab"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3844",
    "data-name": "Path 3844",
    d: "M352.742,201.351c1.218,2.676.221,7.957.644,10.059a19.333,19.333,0,0,0-1.911-1.962c-.111-.121-.221-.221-.322-.312-.111-.111-.2-.2-.282-.272-.172-.161-.272-.261-.272-.261l-.1-.02a3.744,3.744,0,0,0-.121-1.488,1.3,1.3,0,0,0-1.619-.986c-.231.211.422,1.328-.563,1.489s-.695-2.6-1.469-3.289c-.744-.655-4.436.141-4.779.211a.031.031,0,0,1-.02.01,3.218,3.218,0,0,1-1.448-2.545s3.38-.754,5.221-1.3S351.444,198.5,352.742,201.351Z",
    transform: "translate(216.128 81.972)",
    fill: "#739092"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3845",
    "data-name": "Path 3845",
    d: "M349.729,234.279c.241.966.5,1.912.774,2.847a17.113,17.113,0,0,1-4.184,3.894L346.2,241l-.02.111a18.352,18.352,0,0,1-2.123,1.207l-.2-.04-3.963-.795C344.478,239.9,349.729,234.279,349.729,234.279Z",
    transform: "translate(216.223 76.376)",
    fill: "#3b55eb"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3846",
    "data-name": "Path 3846",
    d: "M346.944,220.566l.06-.09a30.171,30.171,0,0,0,.915,11.569s-5.251,5.623-9.838,7.2l-9.366-1.882c3.341-.6,7.545-1.57,9.1-2.907C340.526,232.134,344.741,226.219,346.944,220.566Z",
    transform: "translate(218.033 78.612)",
    fill: "#536dfe"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3847",
    "data-name": "Path 3847",
    d: "M318.1,245.633a5.466,5.466,0,0,0,.855.261s-4.3,1.549-6.1-.543a4.718,4.718,0,0,1-.624-.886c-.755-1.388.312-1.79.815-1.76a1.816,1.816,0,0,1,.322.05c.955.181,3.239.855,3.42,1.73C316.91,245.039,317.543,245.412,318.1,245.633Z",
    transform: "translate(220.744 75.012)",
    fill: "#f8e8ab"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3848",
    "data-name": "Path 3848",
    d: "M284.253,223.613A23.886,23.886,0,1,0,260.372,247.5,23.884,23.884,0,0,0,284.253,223.613Z",
    transform: "translate(232.968 82.689)",
    fill: "#a5b7c6",
    style: {
      mixBlendMode: "hard-light",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3849",
    "data-name": "Path 3849",
    d: "M261.651,212.757a7.07,7.07,0,1,0-7.069,7.073A7.07,7.07,0,0,0,261.651,212.757Z",
    transform: "translate(231.182 81.006)",
    fill: "#a5b7c6",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyList);
export default __webpack_public_path__ + "static/media/empty-list.49ae4008.svg";
export { ForwardRef as ReactComponent };